export const infoOutlinedSvg = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10" cy="10" r="8" stroke="#42526E" stroke-width="1.5"/>
<path d="M10 9V14" stroke="#42526E" stroke-width="1.5" stroke-linecap="round"/>
<circle cx="10" cy="6.5" r="1" fill="#42526E"/>
</svg>`;
